import Vue from 'vue'
import {
  Dialog,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Tabs,
  TabPane,
  Input,
  Checkbox,
  CheckboxButton,
  CheckboxGroup,
  Button,
  ButtonGroup,
  Form,
  FormItem,
  Icon,
  Row,
  Col,
  Loading,
  Popover,
  MessageBox,
  Message,
  Notification,
  Table,
  TableColumn,
  Progress,
} from 'element-ui'

const components = [
  Dialog,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Tabs,
  TabPane,
  Input,
  Checkbox,
  CheckboxButton,
  CheckboxGroup,
  Button,
  ButtonGroup,
  Form,
  FormItem,
  Icon,
  Row,
  Col,
  Popover,
  Table,
  TableColumn,
  Progress,
]

components.forEach(component => Vue.use(component))

Vue.use(Loading.directive)

Vue.prototype.$loading = Loading.service
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$notify = Notification
Vue.prototype.$message = Message
